<template>
	 <v-container style="padding: 0;">
		 <v-dialog title="班级学员详情" v-model="hideShow" width="500" persistent>
			<v-card>
				<v-card-title>
					<span>班级学员详情</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						<v-col cols="12" v-if="classStudentModel">
							<div class="mb-5">
								<div class="d-flex">
									<v-avatar size="60" class="ml-2" style="cursor: pointer;">
										<v-img v-if="classStudentModel.studentAvatar" :src="imgPrev + classStudentModel.studentAvatar" @click="showImageViewer(classStudentModel.studentAvatar)"></v-img>
									</v-avatar>
									<!-- 名字 -->
									<div class="d-flex flex-column ml-3">
										<span class="mt-2" style="color: black; font-weight: 400;">
											{{classStudentModel.studentName}}
										</span>
										
										<v-btn x-small  color="error" @click="deleteClassStudent()">
											删除
										</v-btn>
									</div>
									<v-spacer></v-spacer>
									<div class="d-flex flex-column align-center">
										<v-btn color="info" small @click="showCreateSituation">填写学习状况</v-btn>
										<span @click="showSituationList" class="mt-2" style="cursor: pointer;">查看状况记录</span>
									</div>
								</div>
								<div class="mt-5">
									<!-- 价格 -->
									<div class="d-flex ml-2"  v-if="classStudentModel.consumeType=='2'">
										<span>消课价格：</span>
										<span>
											{{classStudentModel.classPrice}}元/课时
										</span>
										<v-btn  @click="toShowUpdatePrice()" :disabled="classStudentModel.status !=='1'" x-small color="info" class="ml-2">修改价格</v-btn>
									</div>
								</div>
								<div class="mt-5 mb-5">
									<!-- 日期 -->
									<div class="d-flex ml-2">
										<span>进班日期：</span>
										<span>
											{{classStudentModel.joinDate}}
										</span>
										<v-btn  @click="toShowUpdateJoinDate()" :disabled="classStudentModel.status !=='1'" x-small color="info" class="ml-2">修改日期</v-btn>
											
									</div>
								</div>
								<v-divider></v-divider>
								<div class="mt-3" v-if="classStudentModel.isViewTeacherPerformancePrice=='1'">
									<!-- 教师提成计算价格 -->
									<div  class="d-flex ml-2 ">
										<span style="color: red;">注:只有教师绩效提成方式是“按比例分成”,且配置"按指定提成价格计算"提成时需要配置</span>
									</div>
									<div class="d-flex ml-2 mt-2">
										<span>教师提成计算价格：</span>
										<span v-if="classStudentModel.teacherBonusPrice">
											{{classStudentModel.teacherBonusPrice}} 元/课时
										</span>
										<span v-else>-</span>
										<v-btn  @click="toShowUpdateBonusPrice()" :disabled="classStudentModel.status !=='1'" x-small color="info" class="ml-2">设置教师提成价格</v-btn>
											
									</div>
									
								</div>
							</div>
						</v-col>
						
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
		
		<!-- 修改课时单价组件 -->
		<updateStudentPrice :show="updatePrice.show" :classStudent="updatePrice.classStudent"
			@cancel="updatePrice.show=false" @success="priceUpdated"></updateStudentPrice>
		
		<!-- 修改排课时间 -->
		<updateClassTime :show="updateTime.show" :classModel="updateTime.classModel" @cancel="updateTime.show=false"
			@success="classTimeUpdated"></updateClassTime>
			
		<!-- 修改进班日期组件 -->
		<updateStudentJoinDate :show="updateJoinDate.show" :classStudent="updateJoinDate.classStudent" @cancel="updateJoinDate.show=false" 
			@success="updateJoinDateSuccess"></updateStudentJoinDate>
			
		<!-- 修改教师提成价格 -->
		<updateStudentTeacherBonusPrice :show="updateBounsPrice.show" :classStudent="updateBounsPrice.classStudent"
			@cancel="updateBounsPrice.show=false" @success="bonusPriceUpdated"></updateStudentTeacherBonusPrice>
		
		<!-- 图片预览 -->
		<imageViewer :show="imageViewerDialog.show" :imgSrc="imageViewerDialog.imgSrc" imgWidth="400" imgHeight="400" @cancel="imageViewerDialog.show=false"></imageViewer>
		
		<!-- 添加学员状况 -->
		<createStudentSituation :show="createSituationDialog.show" :classStudent="createSituationDialog.classStudent" @cancel="createSituationDialog.show=false" @success="createSituationSuccess"></createStudentSituation>
		<!-- 查看学员状况记录 -->
		<studentSituationList :show="situationListDialog.show" :studentId="situationListDialog.studentId" @cancel="situationListDialog.show=false" ></studentSituationList>
	 </v-container>
</template>

<script>
	import utils from "../config/utils"
	import global from "../config/global"
	import updateStudentPrice from "./update_student_price.vue"
	import updateClassTime from "./update_class_time.vue"
	import updateStudentJoinDate from "./update_student_join_date.vue"
	import updateStudentTeacherBonusPrice from "./update_student_teacher_bonus_price.vue"
	import imageViewer from "./image_viewer.vue"
	import createStudentSituation from "./create_student_situation.vue"
	import studentSituationList from "./student_situation_list.vue"
	export default {
		name:"class-student-detail",
		components: {
			updateStudentPrice,
			updateClassTime,
			updateStudentJoinDate,
			updateStudentTeacherBonusPrice,
			imageViewer,
			createStudentSituation,
			studentSituationList
		},
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			classStudent:{
				type:Object,
				default:null
			}
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					this.classStudentModel = this.classStudent;
				}
			}
		},
		data(){
			return {
				imgPrev:global.config.imgPre,
				hideShow:this.show,
				classStudentModel:null,
				updatePrice:{
					show:false,
					classStudent:null
				},
				updateTime:{
					show:false,
					classStudent:null
				},
				updateJoinDate:{
					show:false,
					classStudent:null
				},
				updateBounsPrice:{
					show:false,
					classStudent:null
				},
				imageViewerDialog:{
					show:false,
					imgSrc:"",
				},
				createSituationDialog:{
					show:false,
					classStudent:null
					
				},
				situationListDialog:{
					show:false,
					studentId:"",
				},
				
			}
		},
		mounted() {
			console.log("class student detail mounted");
		},
		methods:{
			deleteClassStudent() {
				//删除
				const that = this;
				let url = `/edu/class/student/delete/${this.classStudent.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.$emit("leave","")
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
			
				});
			},
			showCreateSituation(){
				// 显示添加学员状态
				this.createSituationDialog.classStudent = this.classStudent;
				this.createSituationDialog.show = true;
				
			},
			showSituationList(){
				// 显示全部状况
				this.situationListDialog.studentId = this.classStudent.studentId;
				this.situationListDialog.show =true;
				
			},
			toShowUpdatePrice() {
				this.updatePrice.classStudent = this.classStudent;
				this.updatePrice.show = true;
			},
			toShowUpdateBonusPrice(){
				this.updateBounsPrice.classStudent = this.classStudent;
				this.updateBounsPrice.show= true;
			},
			priceUpdated(e) {
				this.updatePrice.show = false;
				this.classStudentModel.classPrice = e;
			},
			bonusPriceUpdated(e){
				this.updateBounsPrice.show =false;
				this.classStudentModel.teacherBonusPrice = e;
			},
			showUpdateTime() {
			
				this.updateTime.classModel = this.classModel;
				this.updateTime.show = true;
			},
			classTimeUpdated() {
				this.updateTime.show = false;
				this.getClassDetail();
			},
			toShowUpdateJoinDate(){
				this.updateJoinDate.classStudent = this.classStudent;
				this.updateJoinDate.show = true;
			},
			updateJoinDateSuccess(e){
				this.updateJoinDate.show = false;
				this.classStudentModel.joinDate = e;
			},
			cancel(){
				this.$emit("cancel","");
			},
			showImageViewer(imgSrc){
				this.imageViewerDialog.imgSrc = imgSrc;
				console.log(imgSrc);
				this.imageViewerDialog.show=true;
			},
			createSituationSuccess(){
				this.createSituationDialog.show=false;
			}
		}
	}
	
</script>


